// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid, Row } from 'react-bootstrap';
import { Text, Whitespace } from '../../components_new/common';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';
import Button from '../../components_new/common/FormComponents/Button';
import { CenterContainer } from '../../components_new/common/Containers';

const BulletContainer = styled.ul`
  text-align: left;
`;

const categoryDivStr =
  'p-mxx brad-m inline-block bg-white sh-default relative o-hidden';

export default class Intro extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { store, firstName, nextPage } = this.props;
    return (
      <Grid>
        <Row>
          <CenterContainer
            flexDirection="column"
            width="620px"
            justifyContent="center"
            alignItems="center"
            pt={6}
          >
            <div className="f-self-stretch">
              <Text
                h1
                primary
                bold
                noclip
              >{`Hi ${firstName}! Let's put your stuff to work.`}</Text>
            </div>
            <Whitespace />
            <Flex flexDirection="column" width="850px">
              <Text t-l noclip>
                Here are some of our most popular categories to give you some
                ideas
              </Text>
              <Whitespace smaller />
              <div className="g g-g-mxx g-tc-fr-3">
                <div className={categoryDivStr}>
                  <div className="absolute right-16 top-4 o-hidden">
                    <i className="fas fa-tools offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Tools
                    </Text>
                    <Text grayFaded>Drill, Tablesaw, Paint sprayer</Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-16 top-4 o-hidden">
                    <i className="fas fa-tshirt offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Clothing
                    </Text>
                    <Text grayFaded>Prom Dress, Wedding Dress, Suit</Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-16 top-4 o-hidden">
                    <i className="fas fa-camera-alt offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Electronics
                    </Text>
                    <Text grayFaded>Drone, Camera, Consoles</Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-12 top-4 o-hidden">
                    <i className="fas fa-campground offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Outdoor Gear
                    </Text>
                    <Text grayFaded>Backpack, Fishing, Mountain bike</Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-26 top-4 o-hidden">
                    <i className="fas fa-birthday-cake offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Party & Wedding
                    </Text>
                    <Text grayFaded>Decorations, Bounce house, Chairs</Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-16 top-4 o-hidden">
                    <i className="fas fa-dice offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Toys & Games
                    </Text>
                    <Text grayFaded>
                      Board games, Squirt guns, Frisbee Golf
                    </Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-12 top-4 o-hidden">
                    <i className="fas fa-motorcycle offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Recreational Vehicles
                    </Text>
                    <Text grayFaded>
                      ATV, Side by side, Dirt bike, One-wheel
                    </Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-16 top-4 o-hidden">
                    <i className="fas fa-home-heart offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Home & Kitchen
                    </Text>
                    <Text grayFaded>
                      Kitchenaid, Pizza stone, Carpet cleaner
                    </Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-16 top-4 o-hidden">
                    <i className="fas fa-flower-tulip offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Lawn & Garden
                    </Text>
                    <Text grayFaded>Spring prep kit, Hedge trimmer</Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-16 top-4 o-hidden">
                    <i className="fas fa-skiing offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Sporting Goods
                    </Text>
                    <Text grayFaded>Golf clubs, Skiis, Training nets</Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-16 top-4 o-hidden">
                    <i className="fas fa-archway offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Venues
                    </Text>
                    <Text grayFaded>Private land, Hot tub, Reception Room</Text>
                  </div>
                </div>
                <div className={categoryDivStr}>
                  <div className="absolute right-16 top-4 o-hidden">
                    <i className="fas fa-chalkboard-teacher offWhite fa-5x" />
                  </div>
                  <div className="relative">
                    <Text t-lx grayDark>
                      Local Experts & Services
                    </Text>
                    <Text grayFaded>
                      Your craft skills, your professional skills
                    </Text>
                  </div>
                </div>
              </div>
            </Flex>
            <Whitespace />
            <Flex flexDirection="row" justifyContent="center" width="850px">
              <div className="f f-cc f-rows">
                <Button action onClick={nextPage} primary>
                  GET STARTED
                </Button>
                <Text t-m>est time: 5 minutes</Text>
              </div>
            </Flex>
          </CenterContainer>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_new/addListing/Intro.js